const ANCHOR = {
  HOME: {
    pl: '/',
    en: '/',
    fr: '/',
  },
  BLOG: {
    pl: '/blog',
    en: '/blog',
    fr: '/blog',
  },
  PRIVACY_POLICY: {
    pl: 'https://tenderhut.com/dane-osobowe',
    en: 'https://tenderhut.com/en/personal-data',
    fr: 'https://tenderhut.com/en/personal-data',
  },
  REGULATIONS: {
    pl: '/regulamin-strony',
    en: '/terms-of-use',
    fr: '/conditions-dutilisation',
  },
  APPLICATION_REGULATIONS: {
    pl: '/regulamin-aplikacji',
    en: '/app-terms-of-use',
    fr: '/conditions-dutilisation-de-lapplication',
  },
  CONTACT_FORM: {
    pl: '/contact',
    en: '/contact',
    fr: '/contact',
  },
  LOBBYPASSPORT: {
    pl: '/lobbypassport',
    en: '/lobbypassport',
    fr: '/lobbypassport',
  },
  WORKSPACE: {
    pl: '/workplace',
    en: '/workplace',
    fr: '/workplace',
  },
  TV: {
    pl: '/tv',
    en: '/tv',
    fr: '/tv',
  },
  SERVICES: {
    pl: '/services',
    en: '/services',
    fr: '/services',
  },
  FAQ: {
    pl: '/faq',
    en: '/faq',
    fr: '/faq',
  },
  FOR_INVESTORS: {
    pl: '/for-investors',
    en: '/for-investors',
    fr: '/for-investors',
  },
  THANK_YOU: {
    pl: '/thank-you',
    en: '/thank-you',
    fr: '/thank-you',
  },
  SUBSCRIPTION_CONFIRMED: {
    pl: '/subscription-confirmed',
    en: '/subscription-confirmed',
    fr: '/subscription-confirmed',
  },
  WORK: {
    pl: '/praca',
    en: '/praca',
    fr: '/praca',
  }
};

module.exports = ANCHOR;



// WEBPACK FOOTER //
// ./src/common/consts/anchor.js